export enum GlobalSettingsKeyEnum {
  Products = 'products',
}
